import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    sistemas: {
        overflowX: 'auto',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
            overflowX: 'auto',
            flexWrap: 'nowrap',
        }
    },
    hiddenScroll: {
        [theme.breakpoints.down('sm')]: {
            '&::-webkit-scrollbar': {
                height: 3
            },
            '-ms-overflow-style': 'none',
        }
    },
    gap: {
        gap: theme.spacing(1)
    },
    container: {
        background: theme.palette.common.white,
        padding: theme.spacing(2),
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    }
}))